<!--  -->
<template>
  <div>
    <div class="tinymce_box">
      <div>
        <div class="tabselecr_box">
          <div>
            <el-input v-model="obj.account_id" clearable style="width:200px;" placeholder="请输入推广帐号id" />
            <!-- <el-input v-model="obj.title" clearable style="width:200px;margin-left:10px" placeholder="请输入消息标题" /> -->
            <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
            <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" @click="add(1)">新增行为源</el-button>
            <!-- <el-button type="warning" icon="el-icon-edit" @click="proportion">批量修改比例</el-button> -->
          </div>
        </div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData.list"
          border
          tooltip-effect="dark"
          style="width: 100%;margin-top:20px"
        >
          <!-- <el-table-column
            prop="corp_name"
            label="企业名称"
            align="center"
            width="150px"
          />
          <el-table-column
            prop="corp_id"
            label="企业id"
            align="center"
            width="320px"
          />
          <el-table-column
            prop="corp_userid"
            label="员工id"
            align="center"
            width="300px"
          />
          <el-table-column
            prop="name"
            label="员工名称"
            align="center"
            width="150px"
          /> -->
          <el-table-column
            prop="action_set_rate"
            label="上传比例"
            align="center"
            width="100px"
          />
          <el-table-column
            prop="account_id"
            label="推广帐号id"
            align="center"
            width="150px"
          />
          <!-- <el-table-column
            prop="ad_link"
            label="推广链接"
            align="center"
            width="150px"
          /> -->
          <el-table-column
            prop="type_text"
            label="用户行为源类型"
            align="center"
            width="300"
          />
          <el-table-column
            prop="user_action_set_id"
            label="用户行为源id"
            align="center"
            width="200"
          />
          <el-table-column
            prop="realName"
            label="创建人"
            align="center"
            width="150"
          />
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            align="center"
            width="200"
          />
          <el-table-column
            prop="status_text"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
              <i v-if="scope.row.status == 2" class="el-icon-error stopew" />
              {{ scope.row.status_text }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button type="warning" size="mini" @click="editr(2,scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>

        </el-table>
        <pagination-right
          :current-page="obj.page"
          :total="tableData.total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
    </div>
    <!-- 新增行为源弹窗 -->
    <el-dialog
      title="行为源"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
      append-to-body
      :destroy-on-close="true"
    >
      <behsourcedialog ref="sur" @callback="callback" />
    </el-dialog>
    <!-- 修改比例弹窗 -->
    <el-dialog
      title="修改比例"
      :visible.sync="proportiondialogVisible"
      :close-on-click-modal="false"
      width="25%"
      append-to-body
      :destroy-on-close="true"
    >
      <div>
        <el-form label-position="right" label-width="130px" :model="formLabelAlign">
          <el-form-item label="推广账号id">
            <el-input v-model="formLabelAlign.account_id" style="width:200px" />
          </el-form-item>
          <el-form-item label="上传比例">
            <el-input v-model="formLabelAlign.action_set_rate" style="width:200px" />
          </el-form-item>
          <el-form-item label="用户行为源类型">
            <el-select v-model="formLabelAlign.type" placeholder="请选择">
              <el-option
                v-for="item in optionsr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="sumbort">确定</el-button>
          </el-form-item>
        </el-form></div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { userActionindex, updateRateByAccountId } from '@/api/behavioral.js'
import behsourcedialog from './components/behsourcedialog.vue'
export default {
  name: 'Behavioralsourcetwo',
  components: { PaginationRight, behsourcedialog },
  data() {
    return {
      tableData: [],
      obj: {
        page: 1,
        pageSize: 10,
        account_id: null
        // title: ''
      },
      dialogVisible: false,
      type: '1',
      options: [],
      loading: false,
      templatedata: [],
      templatetotalre: null,
      plateoption: [],
      palateid: null,
      proportiondialogVisible: false,
      optionsr: [{
        value: 'SCANCODE',
        label: '加企业微信客服'
      }, {
        value: 'REGISTER',
        label: '注册'
      },
      {
        value: 'RESERVATION',
        label: '表单预约'
      }],
      formLabelAlign: {
        account_id: '',
        action_set_rate: '',
        type: ''
      }
    }
  },
  created() {
    this.menuList()
  },
  mounted() {

  },
  methods: {
    menuList() {
      this.loading = true
      userActionindex(this.obj).then(res => {
        console.log('res', res)
        this.tableData = res.data
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.obj.pageSize = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.menuList()
    },
    add(type) {
      this.type = type
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sur.opens(type)
      }, 100)
    },
    editr(type, id) {
      this.type = type
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sur.opens(type, id)
      }, 100)
    },
    rechargeclick() {
      this.obj = {
        page: 1,
        pageSize: 10,
        account_id: null
      }
      this.menuList()
    },
    searchclick() {
      this.obj.page = 1
      this.menuList()
    },
    updata() {
      this.dialogTableVisible = false
      this.menuList()
    },
    callback(item) {
      this.dialogVisible = false
      this.menuList()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      console.log(item)
    },
    proportion() {
      this.proportiondialogVisible = true
    },
    async sumbort() {
      if (this.formLabelAlign.account_id === '') {
        this.$message.error('请输入推广帐号id')
        return
      }
      if (this.formLabelAlign.action_set_rate === '') {
        this.$message.error('请输入上传比例')
        return
      }
      const data = await updateRateByAccountId(this.formLabelAlign)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.proportiondialogVisible = false
      this.formLabelAlign.account_id = ''
      this.formLabelAlign.action_set_rate = ''
      this.menuList()
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tinymce_box{
  /* width: 1200px;
  margin: 0 auto;
  margin-top: 50px; */
  padding: 30px;
}
.tinymceserve_box{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox{
  width: 200px;
  margin-left: 20px;
}
.functional_area{
  margin-top: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* width: 90%; */
}
.choose_plate{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text{
  font-size: 14px;
  color: #606266;
}
.template_addbutton{
  text-align: right;
  width: 80%;
}
.sewrw_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box{
  display: flex;
  align-items: center;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
